module.exports = __webpack_public_path__ + "static/img/t24.16dc9b42.png";